import z from "zod";

export const GetRegionalOverridesParamsSchema = z.object({
  enterpriseId: z.number(),
});

export const PricingRegionSchema = z.object({
  id: z.number(),
  name: z.string(),
  regionCode: z.string(),
});

export const RegionalOverrideSchema = z.object({
  id: z.number(),
  sellerPowurlinePpw: z.string(),
  region: z.string(),
  entBaselinePpw: z.string().nullable(),
  startAt: z.string(),
  adderId: z.number(),
  adderName: z.string(),
  regionCode: z.string(),
});

export const RegionalOverrideRequestBodySchema = z.object({
  pricingRegions: z.array(PricingRegionSchema),
  maximumMarginAdjustment: z.number(),
  overrides: z.array(RegionalOverrideSchema),
});

export const GetRegionalOverridesResponseSchema = z.object({
  status: z.number(),
  body: RegionalOverrideRequestBodySchema,
});

export const CreateRegionalOverrideParamsSchema = z.object({
  adderId: z.number(),
  sellerPowurlinePpw: z.string(),
  enterpriseId: z.number(),
  entBaselinePpw: z.string().optional(),
});

export const UpdateRegionalOverrideParamsSchema = z.object({
  id: z.number(),
  enterpriseId: z.number(),
  sellerPowurlinePpw: z.number(),
  entBaselinePpw: z.number().nullable().optional(),
});

export const DeleteRegionalOverrideParamsSchema = z.object({
  id: z.number(),
  enterpriseId: z.number(),
});

export const MutateRegionalOverrideResponseSchema = z.object({
  status: z.number(),
  body: RegionalOverrideSchema,
});
